import React from "react";
import './AverageGraph.scss';
import {AverageGraphData, MyScoreGraphData, SheetGraphData, GradeGraphData, LevelGraphData, LevelGradeGraphData, ClassGraphData} from "./AverageGraphData";
import { NewLoginInfo } from "../../../../data/dto/LoginInfo";
import { GetLevelName, GetSuneongRanking } from "../../../../data/usecase/ReportUsecase";
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend, ResponsiveContainer } from "recharts";

const AverageGraph = (data: any) => {
  return (
    <div className="Graph-container">
      <AverageGraphData data={data.data}/>
    </div>
  );
}

interface NewAverageProp {
  chartData: any,
  graphData: any,
  loginInfo: NewLoginInfo,
  upperlevel: any|null
}

const NewAverageGraph = ({chartData, graphData, loginInfo, upperlevel}: NewAverageProp) => {
  // const [isHovered, setIsHovered] = useState(false);

  return (

    <div>
      <table className="NewAverageGraphTable">
          <tbody>
              <tr>
                  <th>영역</th>
                  <th>점수</th>
                  <th>백분위</th>
              </tr>
              <tr>
                  <td>내 점수</td>
                  <td><MyScoreGraphData data={chartData}></MyScoreGraphData></td>
                  <td>
                    <div className={+loginInfo.test.type >= 3 ? "Display-None" : ""}>-</div>
                    <div className={+loginInfo.test.type >= 3 ? "" : "Display-None"}>{GetSuneongRanking(+chartData.myscore)}등급</div>
                  </td>
              </tr>
              <tr>
                  <td>동유형응시자평균</td>
                  <td><SheetGraphData data={chartData}></SheetGraphData></td>
                  <td>{graphData.sheetPercentage}%</td>
              </tr>
              <tr>
                  <td>학년 평균</td>
                  <td><GradeGraphData data={chartData}></GradeGraphData></td>
                  <td>{graphData.gradePercentage}%</td>
              </tr>
              <tr>
                  <td>{GetLevelName(+loginInfo.studentLevel, loginInfo.test.subject)} 전체 평균</td>
                  <td><LevelGraphData data={chartData}></LevelGraphData></td>
                  <td>{graphData.lvPercentage}%</td>
              </tr>
              <tr>
                  <td>{GetLevelName(+loginInfo.studentLevel, loginInfo.test.subject)} {loginInfo.studentGrade}학년 평균</td>
                  <td><LevelGradeGraphData data={chartData}></LevelGradeGraphData></td>
                  <td>{graphData.lvGradePercentage}%</td>
              </tr>
            
          </tbody>
      </table>
      <div className={+loginInfo.test.type < 3 && upperlevel.lv !== null ? "Desc-Container" : "Display-None"}>
        <div>· {GetLevelName(upperlevel.lv, loginInfo.test.subject)} 평균 : {upperlevel.avg}</div>
      </div>
  </div>
  );
}

const NewMathAverageGraph = ({loginInfo, chartData, graphData}: NewAverageProp) => {

  return (
    <div>
      <table className="NewAverageGraphTable">
          <tbody>
              <tr>
                  <th>영역</th>
                  <th>점수</th>
                  <th>백분위</th>
              </tr>
              <tr>
                  <td>내 점수</td>
                  <td><MyScoreGraphData data={chartData}></MyScoreGraphData></td>
                  <td>
                    <div>-</div>
                  </td>
              </tr>
              <tr>
                  <td>동유형응시자평균<br/>{+loginInfo.test.id < 21 && (<span className="Add-desc">(0.1%, 의대, 특목)</span>)}</td>
                  {+loginInfo.test.id >= 21 && +loginInfo.studentLevel === 3 && (
                    <>
                      <td><LevelGraphData data={chartData}></LevelGraphData></td>
                      <td>{graphData.lvPercentage}%</td>
                    </>
                  )} {!(+loginInfo.test.id >= 21 && +loginInfo.studentLevel === 3) && (
                    <>
                      <td><SheetGraphData data={chartData}></SheetGraphData></td>
                      <td>{graphData.sheetPercentage}%</td>
                    </>
                  )}
              </tr>
              
              <tr>
                  <td>동일 레벨 평균</td>
                  <td><LevelGraphData data={chartData}></LevelGraphData></td>
                  <td>{graphData.lvPercentage}%</td>
              </tr>
          </tbody>
      </table>
  </div>
  );
}

interface V3AverageProp {
  chartData: any,
  graphData: any,
}

const V3MathAverageGraph = ({chartData, graphData}: V3AverageProp) => {

  return (
    <div>
      <table className="NewAverageGraphTable">
          <tbody>
              <tr>
                  <th>영역</th>
                  <th>점수</th>
                  <th>백분위</th>
              </tr>
              <tr>
                  <td>내 점수</td>
                  <td><MyScoreGraphData data={chartData}></MyScoreGraphData></td>
                  <td>
                    <div>-</div>
                  </td>
              </tr>
              <tr>
                  <td>동유형응시자 평균</td>
                    <td><SheetGraphData data={chartData}></SheetGraphData></td>
                    <td>{graphData.sheetPercentage}%</td>
              </tr>
              <tr>
                  <td>반 평균</td>
                  <td><ClassGraphData data={chartData}></ClassGraphData></td>
                  <td>{graphData.classPercentage}%</td>
              </tr>
              <tr>
                  <td>동일 학년 평균</td>
                  <td><GradeGraphData data={chartData}></GradeGraphData></td>
                  <td>{graphData.gradePercentage}%</td>
              </tr>
              {/* <tr>
                  <td>전국 평균</td>
                  <td><NationalGraphData data={chartData}></NationalGraphData></td>
                  <td>{graphData.natPercentage}%</td>
              </tr> */}
          </tbody>
      </table>
  </div>
  );
}

interface AreaRadarProp {
  data: { area: string, student: number, average: number, total: number }[]
}

const AreaRadarChart = ({ data }: AreaRadarProp) => {
  const normalizedData = data.map(d => ({
    area: d.area,
    student: (d.student / d.total) * 100,
    average: (d.average / d.total) * 100,
  }));

  return (
      <ResponsiveContainer width="100%" height="100%">
          <RadarChart data={normalizedData} cx="50%" cy="50%" outerRadius="55%">
              <PolarGrid />
              <PolarAngleAxis dataKey="area" />
              <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
              <Radar name="내 점수" dataKey="student" stroke="rgba(255, 5, 5, 0.8)" fill="rgba(255, 5, 5, 0.3)" />
              <Radar name="동일 학년 평균" dataKey="average" stroke="rgba(0, 0, 195, 0.8)" fill="rgba(0, 0, 195, 0.2)" />
              <Legend />
          </RadarChart>
      </ResponsiveContainer>
  );
}

export { AverageGraph, NewAverageGraph, NewMathAverageGraph, V3MathAverageGraph, AreaRadarChart };
